import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { MagnifyingGlass } from "react-loader-spinner";
import ScrollToTop from "../ScrollToTop";

const MyAccountNotification = () => {
  const navigate = useNavigate();
  const [loaderStatus, setLoaderStatus] = useState(true);
const handleLogout = () => {
  const confirmLogout = window.confirm(
    "Are you sure you want to logout?"
  );

  if (!confirmLogout) return;

  localStorage.clear();
  window.location.href = "/MyAccountSignIn";
};

  /* ======================
     AUTH CHECK
  ====================== */
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/login");
      return;
    }

    const timer = setTimeout(() => {
      setLoaderStatus(false);
    }, 1200);

    return () => clearTimeout(timer);
  }, [navigate]);

  /* ======================
     LOGOUT
  ====================== */
 
  return (
    <div>
      <ScrollToTop />

      <section className="py-4">
        <div className="container">
          <div className="row">

            {/* MOBILE HEADER */}
            <div className="col-12 d-md-none mb-3 d-flex justify-content-between align-items-center">
              <h5 className="mb-0">Notification Settings</h5>
              <button
                className="btn btn-outline-secondary"
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasAccount"
              >
                <i className="fas fa-bars"></i>
              </button>
            </div>

            {/* SIDEBAR */}
            <div className="col-lg-3 d-none d-md-block border-end">
              <ul className="nav flex-column nav-pills p-4 gap-2">
                <li>
                  <Link className="nav-link" to="/MyAccountOrder">
                    <i className="fas fa-shopping-bag me-2" /> Your Orders
                  </Link>
                </li>
                <li>
                  <Link className="nav-link" to="/MyAccountSetting">
                    <i className="fas fa-cog me-2" /> Settings
                  </Link>
                </li>
                <li>
                  <Link className="nav-link" to="/MyAccountAddress">
                    <i className="fas fa-map-marker-alt me-2" /> Address
                  </Link>
                </li>
                <li>
                  <Link className="nav-link" to="/MyAccountPayment">
                    <i className="fas fa-credit-card me-2" /> Payment Method
                  </Link>
                </li>
                <li>
                  <Link className="nav-link active" to="/MyAccountNotification">
                    <i className="fas fa-bell me-2" /> Notification
                  </Link>
                </li>
                <hr />
                <li>
               
<button
  type="button"
  className="dropdown-item text-danger"
  onClick={() => {
    const ok = window.confirm("Are you sure you want to logout?");
    if (!ok) return;

    // 🔔 SHOW TOAST
    const toastEl = document.getElementById("logoutToast");
    if (toastEl && window.bootstrap) {
      const toast = new window.bootstrap.Toast(toastEl, {
        delay: 1500,
      });
      toast.show();
    }

    // ⏳ thoda delay so toast dikh jaaye
    setTimeout(() => {
      localStorage.clear();
      window.location.href = "/MyAccountSignIn";
    }, 1200);
  }}
>
  Logout
</button>

                </li>
              </ul>
            </div>

            {/* MAIN CONTENT */}
            <div className="col-lg-9">
              {loaderStatus ? (
                <div className="text-center my-5">
                  <MagnifyingGlass height="80" width="80" color="#0aad0a" />
                </div>
              ) : (
                <div className="p-4">
                  <h2 className="mb-4">Notification Settings</h2>

                  {/* EMAIL */}
                  <div className="mb-5">
                    <h5>Email Notifications</h5>
                    <div className="form-check form-switch my-3">
                      <input className="form-check-input" type="checkbox" />
                      <label className="form-check-label">
                        Weekly Notifications
                      </label>
                    </div>
                    <div className="form-check form-switch">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        defaultChecked
                      />
                      <label className="form-check-label">
                        Account Summary
                      </label>
                    </div>
                  </div>

                  <hr />

                  {/* ORDER UPDATES */}
                  <div className="mb-5">
                    <h5>Order Updates</h5>
                    <div className="form-check form-switch my-3">
                      <input className="form-check-input" type="checkbox" />
                      <label className="form-check-label">
                        Text Messages
                      </label>
                    </div>
                    <div className="form-check form-switch">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        defaultChecked
                      />
                      <label className="form-check-label">
                        Call Before Checkout
                      </label>
                    </div>
                  </div>

                  <hr />

                  {/* WEBSITE */}
                  <div>
                    <h5>Website Notifications</h5>
                    <div className="form-check my-2">
                      <input className="form-check-input" type="checkbox" defaultChecked />
                      <label className="form-check-label">
                        Order Delivery Updates
                      </label>
                    </div>
                    <div className="form-check my-2">
                      <input className="form-check-input" type="checkbox" />
                      <label className="form-check-label">
                        Promotions & Offers
                      </label>
                    </div>
                  </div>

                  <p className="text-muted mt-4">
                    ⚠️ Notification preferences will be saved automatically in a future update.
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* OFFCANVAS MOBILE */}
      <div className="offcanvas offcanvas-start" id="offcanvasAccount">
        <div className="offcanvas-header">
          <h5>My Account</h5>
          <button className="btn-close" data-bs-dismiss="offcanvas" />
        </div>
        <div className="offcanvas-body">
          <ul className="nav flex-column gap-2">
            <li><Link to="/MyAccountOrder" className="nav-link">Your Orders</Link></li>
            <li><Link to="/MyAccountNotification" className="nav-link active">Notification</Link></li>
            <li>
              <li></li>
              <button
                className="nav-link text-danger btn btn-link text-start"
                onClick={handleLogout}
              >
                Logout
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default MyAccountNotification;
